import {LatestStoriesRoot} from './root';
import {LatestStoriesTitle} from './title';
import {LatestStoriesCarousel} from './carousel';

export const latestStories = {
  root: LatestStoriesRoot,
  title: LatestStoriesTitle,
  carousel: LatestStoriesCarousel,
};
